import { render, staticRenderFns } from "./CurveDashboard.vue?vue&type=template&id=3b3e6efa&scoped=true"
import script from "./CurveDashboard.vue?vue&type=script&lang=js"
export * from "./CurveDashboard.vue?vue&type=script&lang=js"
import style0 from "./CurveDashboard.vue?vue&type=style&index=0&id=3b3e6efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e6efa",
  null
  
)

export default component.exports